import BaseClient from '@/app/model/api/response/baseApiClient'

class MasterFieldDeleteApi extends BaseClient {
  public doMasterFieldDelete (id: string) {
    const path: string = '/v1/master/fields/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new MasterFieldDeleteApi()
